import { Flex } from "@chakra-ui/layout";
import { useState } from "react";
import colors from "theme/colors";
import OutlineButton from "components/Button/OutlineButton";
import { Popover } from "antd";
import { MdKeyboardArrowDown } from "react-icons/md";
import { Box, Text } from "@chakra-ui/react";
import ButtonExportarExcel from "ui/components/Button/ButtonExportarExcel";
import ButtonExportarPDF from "ui/components/Button/ButtonExportarPDF";

function OpcoesSearch({
  onExportPdf,
  onExportarXlsx,
  onImprimir,
}: {
  onExportPdf: () => any;
  onExportarXlsx: () => any;
  onImprimir: () => any;
}) {
  const [popoverVisible, setPopoverVisible] = useState(false);

  const onClose = () => setPopoverVisible(false);

  return (
    <Flex>
      <Popover
        placement="bottomRight"
        arrowContent={<></>}
        arrowPointAtCenter={false}
        overlayClassName="antd-popover-hide-arrow"
        trigger="click"
        visible={popoverVisible}
        onVisibleChange={setPopoverVisible}
        overlayStyle={{
          borderRadius: 12,
          zIndex: 3,
          marginLeft: 10,
        }}
        overlayInnerStyle={{
          borderRadius: 12,
          boxShadow: "0 0 6px 2px #87878725",
          border: `solid 1px ${colors.blue}`,
          marginTop: -10,
          marginRight: -2,
          padding: 0,
        }}
        content={() => (
          <PopoverContent
            onExportPdf={onExportPdf}
            onExportarXlsx={onExportarXlsx}
            onImprimir={onImprimir}
            onClose={onClose}
          />
        )}
      >
        <OutlineButton lineColor={colors.blue} p={3} w="142px">
          <Text>Mais opções</Text>

          <Box w="20px" ml={-2}>
            <MdKeyboardArrowDown size={25} />
          </Box>
        </OutlineButton>
      </Popover>
    </Flex>
  );
}

const PopoverContent = ({
  onExportPdf,
  onExportarXlsx,
  onImprimir,
  onClose,
}: {
  onExportPdf: () => any;
  onExportarXlsx: () => any;
  onImprimir: () => any;
  onClose: () => any;
}) => (
  <Flex flexDir="column" alignItems="start" w="110px">
    <ButtonExportarPDF
      onClick={() => {
        onExportPdf();
        onClose();
      }}
    />
    <ButtonExportarExcel
      onClick={() => {
        onExportarXlsx();
        onClose();
      }}
    />
    {/* <ButtonImprimir
      onClick={() => {
        onImprimir();
        onClose();
      }}
    /> */}
  </Flex>
);

export default OpcoesSearch;
